import { PrimitiveType } from '../../../../api/api';
import { ObjectPropertyType } from "../ObjectPropertyType";
import { ObjectSchemaType } from "../ObjectSchemaType";
import { VariableScope } from './VariableScope';

/**
 * Variable scope for collections that provides access to collection-specific variables
 * and the underlying item type
 */
export class CollectionVariableScope extends VariableScope {
	private itemType: ObjectSchemaType | ObjectPropertyType;

	constructor(itemType: ObjectSchemaType | ObjectPropertyType) {
		// Initialize with collection-specific variables
		const collectionVariables = new Map<string, ObjectPropertyType>();

		// Add the $Size variable that returns the number of items in the collection
		collectionVariables.set('$Size', {
			name: '$Size',
			type: PrimitiveType.Integer,
			isComplex: false,
			isMultiple: false,
			isRequired: false,
		} as ObjectPropertyType);

		super(collectionVariables);
		this.itemType = itemType;
	}

	/**
	 * Gets the type of items in this collection
	 */
	getItemType(): ObjectSchemaType | ObjectPropertyType {
		return this.itemType;
	}

	/**
	 * Checks if this collection contains complex objects (ObjectSchemaType)
	 */
	hasComplexItems(): boolean {
		return this.itemType && typeof this.itemType === 'object' && 'properties' in this.itemType;
	}

	/**
	 * Gets the schema of complex items in the collection, or undefined if items are primitive
	 */
	getItemSchema(): ObjectSchemaType | undefined {
		if (this.hasComplexItems()) {
			return this.itemType as ObjectSchemaType;
		}
		return undefined;
	}
}
